import React, { lazy, Suspense, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect, Route, Switch } from 'react-router-dom'

import { RouteAuthWrapper } from 'src/auth/RouteAuthWrapper'
import { useIsAgencySettingsLoaded } from 'src/layout/AgencySettings'
import { useIsProvidersLoaded } from 'src/layout/hooks'
import { useIsMapLayerLoaded } from 'src/layout/MapLayerWrapper'
import routes from 'src/routes'

import Loader from './Loader'

const AppLayout = lazy(() => import('src/layout/AppLayout'))
const EmailReport = lazy(() => import('src/pages/EmailReport/EmailReport'))

function Pages() {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const isAgencySettingsLoaded = useIsAgencySettingsLoaded()
  const isMapLayerLoaded = useIsMapLayerLoaded()
  const isProvidersLoaded = useIsProvidersLoaded()

  useEffect(() => {
    if (isAgencySettingsLoaded && isProvidersLoaded && isMapLayerLoaded) {
      setIsLoading(false)
    }
  }, [isAgencySettingsLoaded, isMapLayerLoaded, isProvidersLoaded])

  if (isLoading) {
    return <Loader />
  }

  return (
    <RouteAuthWrapper routes={routes(t)}>
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route exact={true} path="/email-report" component={EmailReport} />
          <Route path="/" component={AppLayout} />
          <Redirect to="/" />
        </Switch>
      </Suspense>
    </RouteAuthWrapper>
  )
}

export default Pages
